var map = {
	"./Geva Hason - Ani Eshtagea.mp3": 6893,
	"./Geva Hason - Hatishma Koli.mp3": 4741,
	"./Geva Hason - Ima Yekara Li.mp3": 386,
	"./Geva Hason - Ir Miklat.mp3": 8628,
	"./Geva Hason - Mehapes Otah Bahoshech.mp3": 6279,
	"./Geva Hason - Tni Li Yad.mp3": 2799
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7508;